import "./TheApexStory.module.css";
import Header from "@/reusable_sections/Header";
import OurTechnicalVision from "./sections/OurTechnicalVision";
import TheArchitectsOfInnovation from "./sections/TheArchitectsOfInnovation";
import OurCoreValues from "./sections/OurCoreValues";
import Footer from "@/reusable_sections/Footer";
export default function TheApexStoryPage() {
  return <div>
      <Header />
      <OurTechnicalVision />
      <TheArchitectsOfInnovation />
      <OurCoreValues />
      <Footer />
    </div>;
}